// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.main{

  height: 600px;background-color: blue;

}

.sidebar{


  height:600px ;background-color: black;
}

.content{
  height: 600px;background-color: grey;
}

.sidebar ul li{color: white;
  list-style-type:none;
  margin-top: 20px;
  padding: 10px;

}

.sidebar ul li:hover{
  background-color: grey;

  border-radius: 10px;
}

.sidebar ul li a{
  text-decoration: none;
  color: white;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;;EAEE,aAAa,CAAC,sBAAsB;;AAEtC;;AAEA;;;EAGE,aAAa,CAAC,uBAAuB;AACvC;;AAEA;EACE,aAAa,CAAC,sBAAsB;AACtC;;AAEA,eAAe,YAAY;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;;AAEf;;AAEA;EACE,sBAAsB;;EAEtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB","sourcesContent":["\n.main{\n\n  height: 600px;background-color: blue;\n\n}\n\n.sidebar{\n\n\n  height:600px ;background-color: black;\n}\n\n.content{\n  height: 600px;background-color: grey;\n}\n\n.sidebar ul li{color: white;\n  list-style-type:none;\n  margin-top: 20px;\n  padding: 10px;\n\n}\n\n.sidebar ul li:hover{\n  background-color: grey;\n\n  border-radius: 10px;\n}\n\n.sidebar ul li a{\n  text-decoration: none;\n  color: white;\n  font-size: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
